/**
 * 纸媒热点
 */
"use strict";
angular.module("newsPaperChannelHotSpotsModule", ['hotSpotsTopModule']).
controller("newsPaperChannelHotSpotsCtrl", ["$scope", "trsHttpService", "$q", "dateFilter", "hotFocusService", function($scope, trsHttpService, $q, dateFilter, hotFocusService) {
    initStatus();
    initData();

    function initStatus() {
        $scope.data = {
            newPaperCountryTop: [], // 纸媒全国头版TOP5
            curNPCountryTop: {}, // 当前纸媒全国头版TOP5稿件
            newPaperAreaTop: [], // 地域头版TOP5
            curNPAreaTop: {}, // 当前地域头版top5
            curTopManus: {}, //当前选中top稿件
            curHotManus: {}, //当前热点列表
            curManusImg: {}, // 当前选中的稿件版面图
            viewLists: [],
            hotManuLists: [],
            isImgInfo: false, // 是否有版面数据
            isViewsInfo: false, // 是否有观点信息
        }

        $scope.page = {
            "STARTPAGE": '1',
            "PAGESIZE": '10'
        };
        $scope.viewPointListPage = {
            pageno: '0',
            pagesize: '4'
        }
        $scope.data.curNPCountryTop = $scope.data.newPaperCountryTop[0];
        $scope.data.curNPAreaTop = $scope.data.newPaperAreaTop[0];
    }

    function initData() {
        $scope.loadingPromise = $q.all([requestNPAreaHotList('0'), requestNPAreaHotList('1')]).then(function(data) {
            //默认取值全国热点的第一个
            if (data[0].PAGEITEMS  && data[0].PAGEITEMS.length > 0) {
                $scope.data.curTopManus = $scope.data.newPaperCountryTop[0];
                reqManuViewPoint();
                reqHotManuList();
                return;
            }
            //如果全国热点为空，则默认取区域热点的第一个
            if (data[1].PAGEITEMS  && data[1].PAGEITEMS.length > 0) {
                $scope.data.curTopManus = $scope.data.newPaperAreaTop[0];
                reqManuViewPoint();
                reqHotManuList();
            }
        });
    }

    /**
     * [requestlistList description] 纸媒地域性头版TOP5
     * @param  {[type]} area [description]
     * @return {[type]}      [description]
     */
    function requestNPAreaHotList(area) {
        var defer = $q.defer();
        var areaParam = area ? area : '0'
        var params = {
            typeid: "widget",
            serviceid: "channelPaperHotpointMgr",
            modelid: "getHotPointList",
            isprovince: areaParam,
            page_no: '0',
            page_size: '5'
        };
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.PAGEITEMS  && data.PAGEITEMS.length > 0) {
                if (areaParam == '0') {
                    $scope.data.newPaperCountryTop = data.PAGEITEMS;
                    // $scope.data.curTopManus = $scope.data.newPaperCountryTop[0];
                }
                if (areaParam == '1') {
                    $scope.data.newPaperAreaTop = data.PAGEITEMS;
                }
            }
            defer.resolve(data);
        });
        return defer.promise;
    }

    /**
     * [reqManuscriptDetail description]请求热点稿件列表
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    function reqHotManuList() {
        var params = {
            typeid: "widget",
            serviceid: "channelPaperHotpointMgr",
            modelid: "getPaperList",
            id: $scope.data.curTopManus.ID,
            page_no: $scope.page.STARTPAGE-1,
            page_size: $scope.page.PAGESIZE
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.PAGEITEMS && data.PAGEITEMS.length > 0) {
                $scope.data.hotManuLists = data.PAGEITEMS;
                $scope.data.curHotManus = $scope.data.hotManuLists[0];
                $scope.page = {
                    STARTPAGE: data.STARTPAGE+1,
                    PAGESIZE: data.PAGESIZE,
                    ITEMCOUNT: data.TOTALITEMCOUNT,
                    PAGECOUNT: data.PAGETOTAL
                }
                $scope.requestBmts($scope.data.curHotManus);
            }
        });
    }

    /**
     * 请求版面
     * @return {[type]} [description]
     */
    $scope.requestBmts = function(item) {
        $scope.data.curManusImg = {};
        var params = {
            typeid: "widget",
            serviceid: "channelPaperHotpointMgr",
            modelid: "getBmts",
            // id: '1ad2450e-3319-4519-afef-7df695251276',
            id: $scope.data.curTopManus.ID,
            page_no: '0',
            page_size: '1'
        };
        if (item) {
            $scope.data.curHotManus = item;
            params.guid = item.GUID;
        }
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.PAGEITEMS && data.PAGEITEMS.length > 0) {
                $scope.data.curManusImg = data.PAGEITEMS[0];
                $scope.data.isImgInfo = $scope.data.curManusImg.JPGPATH?false:true;
                $("<img/>").attr("src", $scope.data.curManusImg.JPGPATH).load(function() {
                    var containerWidth = $(".look_layout_content").width();
                    var realWidth = this.width;
                    var realHeight = this.height;
                    var aspectRatio = realWidth / realHeight;
                    var height = parseInt(containerWidth / aspectRatio);
                    // $('.left_Img').css({ 'width': 239 });
                    $("#Img_a_image").css({ 'width': containerWidth, 'height': height });
                    $("#Img_a_canvas").attr({ 'width': containerWidth, 'height': height });

                    var newCoor = CoordMax($scope.data.curManusImg.BMZB, containerWidth, height, realWidth, realHeight);
                    setAreaOver(newCoor, 'Img_a_canvas', '71,134,255', '71,134,255', '0.2');
                });
            }
        });
    }

    $scope.lookBmts = function() {
        var item = $scope.data.curTopManus;
        hotFocusService.viewLayout(item);
    }

    /**
     * [setAreaOver description]
     * @param {[type]} coords [description]canvas坐标
     * @param {[type]} id     [description]canvasId
     * @param {[type]} b      [description]id下区域颜色
     * @param {[type]} c      [description]覆盖区域颜色
     * @param {[type]} o      [description]透明度
     */
    function setAreaOver(coords, id, b, c, o) {

        var canvascheck = document.createElement('canvas');
        var isVM = document.namespaces ? 1 : 0;
        var isCV = canvascheck.getContext ? 1 : 0;

        if (isVM) {
            if (document.namespaces['v'] == null) {
                var stl = document.createStyleSheet();
                //stl.addRule("v\\:*", "behavior: url(#default#VML); antialias: true;");

                document.namespaces.add("v", "urn:schemas-microsoft-com:vml");
            }
        }

        var i, j, x, y, context, p = '',
            canvas = document.getElementById(id);
        var v = coords.split(",");
        //  先清除
        if (isVM) { canvas.innerHTML = ''; }
        if (isCV) {
            var context = canvas.getContext("2d");
            context.clearRect(0, 0, canvas.width, canvas.height);
        }

        // 开始画
        if (isVM) {
            for (j = 2; j < v.length; j += 2) { p += parseInt(v[j]) + ',' + parseInt(v[j + 1]) + ','; }
            canvas.innerHTML = '<v:shape strokeweight="1" filled="t" stroked="' + (n < 1 ? "t" : "f") + '" strokecolor="#' + b + '" coordorigin="0,0" coordsize="' + canvas.width + ',' + canvas.height + '" path="m ' + parseInt(v[0]) + ',' + parseInt(v[1]) + ' l ' + p + ' x e" style="zoom:1;margin:0;padding:0;display:block;position:absolute;top:0px;left:0px;width:' + canvas.width + 'px;height:' + canvas.height + 'px;"><v:fill color="#' + c + '" opacity="' + o + '" /></v:shape>';
        }
        if (isCV) {
            context.moveTo(v[0], v[1]);
            for (j = 2; j < v.length; j += 2) { context.lineTo(v[j], v[j + 1]); }
            context.closePath();
            context.fillStyle = 'rgba(' + c + ',' + o + ')';
            context.strokeStyle = 'rgba(' + b + ',0)'; //边框线暂时为透明
            context.fill();
            context.stroke();
            fadeCanvas(id, 0);
        }
    }

    function fadeCanvas(id, opac) {
        var obj = document.getElementById(id);
        if (opac <= 100) {
            obj.style.opacity = opac / 100;
            opac += 10;
            window.setTimeout(fadeCanvas(id, opac), 10);
        }
    }

    function CoordMax(coord, w, h, realW, realH) {
        var arrays = coord.split(',');
        var cd;
        var newCoord = arrays.map(function(v, k) {
            if ((k % 2) == 0) {
                cd = v / realW * w;
            } else {
                cd = v / realH * h;
            }
            return cd.toFixed(2);
        }, this).toString();
        return newCoord;
    }

    /**
     * [reqManuscriptDetail description]稿件各方观点
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    function reqManuViewPoint() {
        var params = {
            typeid: "widget",
            serviceid: "channelPaperHotpointMgr",
            modelid: "getViewPoint",
            page_no: $scope.viewPointListPage.pageno,
            page_size: $scope.viewPointListPage.pagesize,
            id: $scope.data.curTopManus.ID
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.PAGEITEMS && data.PAGEITEMS.length > 0) {
                $scope.data.viewLists = data.PAGEITEMS;
                $scope.viewPointListPage = {
                    pageno: data.PAGEINDEX,
                    pagesize: data.PAGESIZE,
                    totalnum: data.TOTALITEMCOUNT,
                    totalpages: data.TOTALPAGECOUNT
                };
            } else {
                $scope.data.isViewsInfo = true;
            }
        });
    }

    /**
     * [moveLeftViews 左移]
     * @return {[type]} [description]
     */
    $scope.moveLeftViews = function() {
        if ($scope.viewPointListPage.pageno <= 0) {
            return;
        }
        $scope.viewPointListPage.pageno--;
        reqManuViewPoint();
    }

    /**
     * [moveRightViews 右移]
     * @return {[type]} [description]
     */
    $scope.moveRightViews = function() {
        if (!$scope.viewPointListPage.totalpages || ($scope.viewPointListPage.pageno + 1) > $scope.viewPointListPage.totalpages) {
            return;
        }
        $scope.viewPointListPage.pageno++;
        reqManuViewPoint();
    }

    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        reqHotManuList();
    };

    /**
     * [clickTopCallback description]TOP列表回调
     * @return {[type]} [description]
     */
    $scope.clickTopCallback = function() {
        $scope.page.STARTPAGE = 1;
        $scope.viewPointListPage = {
            pageno: '0',
            pagesize: '4'
        }
        $scope.data.isViewsInfo = false;
        $scope.data.viewLists = [];
        reqHotManuList();
        reqManuViewPoint();
    }
}]);